// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"YN-z","carouselContainer":"ZN-z"};